import './form-vehicle.scss';

import { VehicleFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import ImageControl from '@shared/ui/hook-form/image-control/image-control';
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { Divider } from 'primereact/divider';
import { useFormContext } from "react-hook-form";

type InputFormSchema = VehicleFormSchema;
export function FormVehicle() {
  const { control } = useFormContext<VehicleFormSchema>();
  return (
    <div id="FormVehicle" className="vehicle">
      <ImageControl<InputFormSchema>
        control={control}
        name="file"
        label="Person Photo"
        imagePreviewClass="w-32 h-32"
      />
      <Divider />
      <InputControl<InputFormSchema>
        control={control}
        name="plateNumber"
        label="Plate Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter plateNumber"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="make"
        label="Make"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter make"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="model"
        label="Model"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter model"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="year"
        label="Year"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter year"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="color"
        label="Color"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter color"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="nickname"
        label="Nickname"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter nickname"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="remarks"
        label="Remarks"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter remarks"
      />
    </div>
  );
}

export default FormVehicle;
